import { MeasureConfigAverageType } from "@algomusinc/domain";
import { EventEmitter } from "@angular/core";

 const BuildHierarchy = (flatList: any[]): any[] => {
    const nodeMap = new Map<number, any>(); // Fast lookup for nodes
    const rootNodes: any[] = []; // Store root elements

    // Add nodes to map
    flatList.forEach(node => nodeMap.set(node.data, { ...node, children: [] }));

    // Assign children to parents dynamically
    flatList.forEach(node => {
      if (node.parentId) {
        const parent = nodeMap.get(node.parentId);
        if (parent) {
          parent.children.push(nodeMap.get(node.data));
        }
      } else {
        rootNodes.push(nodeMap.get(node.data)); // Root nodes (highest level)
      }
    });

    return rootNodes;
  }
  const AggregateMeasures = (
    node: any,
    parentKey: string,
    masterMeasureList: any[]
  ) => {
    if (!node.children || node.children.length === 0) return node; // Base case (leaf nodes)

    node[parentKey] = node[parentKey] || {}; // Ensure measure storage exists

    // Initialize measures for aggregation
    masterMeasureList.forEach(measure => {
      const config = measure.measureConfigData;
      if (config.isComment) {
        node[parentKey][measure.code] = ""; // Text measures
      }
      else {
        node[parentKey][measure.code] = 0; // Numeric measures
      }
    });
    // Aggregate from children to parent
    node.children.forEach((child: any) => {
      AggregateMeasures(
        child, parentKey, masterMeasureList
      );
      masterMeasureList.forEach(measure => {
        const config = measure.measureConfigData;
        if (config.isComment) {
          node[parentKey][measure.code] = child[parentKey][measure.code] || ""; // Text measures
        }
        else if (config.isLowHierarchy || config.isMultipleAggregated) {
          node[parentKey][measure.code] = child[parentKey][measure.code];
        }
        else if (config.isSpreadEqual) {
          if (config.isPercent) {
            node[parentKey][measure.code] = child[parentKey][measure.code];
          } else {
            node[parentKey][measure.code] = node[parentKey][measure.code] > child[parentKey][measure.code] ? node[parentKey][measure.code]: child[parentKey][measure.code];
          }
        } else if (config.isAveraged === MeasureConfigAverageType.RollupAverage
              || config.isAveraged === MeasureConfigAverageType.BothTotalAndRollupAverage
          ) {
              if (!node[parentKey].__avgTemp) node[parentKey].__avgTemp = {};
              if (!node[parentKey].__avgTemp[measure.code]) {
                node[parentKey].__avgTemp[measure.code] = { sum: 0, count: 0 };
              }
              const value = parseFloat(child[parentKey][measure.code]);
              let condition = config.isSplitPercent ? !isNaN(value) && value : !isNaN(value);
              if (condition) {
                if((config.ignoreZeros && value > 0 ) || !config.ignoreZeros){
                  node[parentKey].__avgTemp[measure.code].sum += value;
                  node[parentKey].__avgTemp[measure.code].count += 1;
                }
              }
        } else if (config.isPercent) {
          node[parentKey][measure.code] = child[parentKey][measure.code];
        }else {
          node[parentKey][measure.code] += parseFloat(child[parentKey][measure.code] || "0"); // Sum up numeric values
        }
      });
    });

    // Finalize roll-up averages
    masterMeasureList.forEach(measure => {
      const config = measure.measureConfigData;
      if ((config.isAveraged === MeasureConfigAverageType.RollupAverage
        || config.isAveraged === MeasureConfigAverageType.BothTotalAndRollupAverage)
          && node[parentKey].__avgTemp
          && node[parentKey].__avgTemp[measure.code]
      ) {
        const temp = node[parentKey].__avgTemp[measure.code];
        node[parentKey][measure.code] = temp.count > 0 ? temp.sum / temp.count : 0;
      }
    });

    // Cleanup temp roll-up storage
    if (node[parentKey].__avgTemp) {
      delete node[parentKey].__avgTemp;
    }

    // Handle percentage calculations
    masterMeasureList.forEach(measure => {
      const config = measure.measureConfigData;
      if (config.isPercent
          && config.isAveraged !== MeasureConfigAverageType.RollupAverage
          && config.isAveraged !== MeasureConfigAverageType.BothTotalAndRollupAverage
        ) {
        node[parentKey][measure.code] = node.children.every((c: any) => c[parentKey][measure.code] == node[parentKey][measure.code]) ? node[parentKey][measure.code]: "Multiple %";
      }else if(config.isMultiple){
        node[parentKey][measure.code] = node.children.every((c: any) => c[parentKey][measure.code] == node[parentKey][measure.code]) ? node[parentKey][measure.code]: "Multiple";
      }
      if (config.isComment) {
        node[parentKey][measure.code] = node.children.every((c: any) => c[parentKey][measure.code] == node[parentKey][measure.code]) ? node[parentKey][measure.code]: "Multiple Comments";
      }
    });

    return node;
  }
  export const ProcessTreeResponse = (
    flatList: any[],
    parentKey: string,
    masterMeasureList: any[]
  ) => {
    const tree = BuildHierarchy(flatList);

    tree.forEach(rootNode =>
      AggregateMeasures(rootNode, parentKey, masterMeasureList)
    );

    return tree;
  }
